/* Gallery prodotto */
(function($){
    function initSwiper_gallery_prodotto_container(){
        if (typeof Swiper !== 'undefined') {
            new Swiper('.gallery-prodotto-container .swiper', {
                loop: false,
                slidesPerView: 1,
                spaceBetween: 0,
                pagination: {
                    el: '.gallery-prodotto-container .swiper .swiper-pagination',
                    clickable: true,
                },
                navigation: {
                    nextEl: '.gallery-prodotto-container .swiper .swiper-button-next',
                    prevEl: '.gallery-prodotto-container .swiper .swiper-button-prev',
                },
                autoplay: {
                    delay: 3000,      // tempo in ms tra una slide e l'altra
                    disableOnInteraction: false // continua anche dopo interazione
                }
            });
        }
    }

    $(document).ready(initSwiper_gallery_prodotto_container);

    $(window).on('elementor/frontend/init', function(){
        elementorFrontend.hooks.addAction(
            'frontend/element_ready/gallery_prodotto.default',
            initSwiper_gallery_prodotto_container
        );
    });
})(jQuery);



// WEBPACK FOOTER //
// ./js/widget/gallery-prodotto.js